import {
  afterRenderEffect,
  effect,
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  viewChild,
  viewChildren, Input, Output, EventEmitter
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Combobox, ComboboxInput, ComboboxPopupContainer } from '@angular/aria/combobox';
import { Listbox, Option } from '@angular/aria/listbox';
import { OverlayModule } from '@angular/cdk/overlay';
import { NominatimApiService, AddressResult } from '../../Api/AdressApi/nominatim_api'
import { CommonModule, AsyncPipe } from '@angular/common';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap, of, filter, from, Observable, OperatorFunction } from 'rxjs';
import { Address } from '../../Api/DcoApi/Address';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap/typeahead';
import {address, dhl_address_api} from '../../Api/AdressApi/DHLAddressApi';

@Component({
  imports: [
   Combobox,
    ComboboxInput,
    ComboboxPopupContainer,
    Listbox,
    Option,
    OverlayModule,
    FormsModule,
    AsyncPipe,
    CommonModule,
    NgbTypeahead
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'Address',
  templateUrl: './AddressEdit.html',
  standalone: true,
  styleUrl: './AddressEdit.css'
})
export class AddressEdit {

  Api: dhl_address_api;

  isEditable: boolean = false;

  toggleIsEdit() {
    this.isEditable = !this.isEditable;
  }


  Items: OperatorFunction<string, address[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(async (term) => {
        if (term?.length > 3 && term.trimStart().includes(" ")) {
          return await this.Api.search(term.trim().replace(" ", "+"));
        }
        // Falls Bedingung nicht erfüllt: Leeres Array zurückgeben
        return [];
      })
    );

  formatter: (obj: any) => string = obj => this.formatAddress(obj);


  formatAddress(address: any): string {
    if (!address) return '';
    // Achte auf Kleinschreibung, da Nominatim meist kleingeschriebene Keys liefert
    return `${address.straße ?? ''} ${address.hausnummer ?? ''}, ${address.plz ?? ''} ${address.ort ?? ''}`.trim();
  }
  constructor() {
    // Scrolls to the active item when the active option changes.
    // The slight delay here is to ensure animations are done before scrolling.

    this.Api = new dhl_address_api();


  }

  get AddressIntern(): Address {
    if (!this.address || this.address == null) {
      this.address = {};
      this.addressChange.emit(this.address);
    }


    return this.address;

  }


  onInputBlur(event: FocusEvent) {

  }


  @Input() address: Address | null = null;

  slection: any = null;

  // MUST be named exactly 'addressChange' for [(address)] to work
  @Output() addressChange = new EventEmitter<Address | null>();

  updateFormFields(selection: any) {
    if (this.address == null) {
      this.address = new Address();
    }

    if (selection != null) {
      this.address.hausnummer = selection?.hausnummer;
      this.address.ort = selection?.ort;
      this.address.plz = selection?.plz;
      this.address.strasse = selection?.straße;
      this.addressChange.emit(this.address);
    }
  }
}

/*
import {
  afterRenderEffect,
  effect,
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  viewChild,
  viewChildren, Input, Output, EventEmitter
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Combobox, ComboboxInput, ComboboxPopupContainer } from '@angular/aria/combobox';
import { Listbox, Option } from '@angular/aria/listbox';
import { OverlayModule } from '@angular/cdk/overlay';
import {dhl_address_api, AddressResult, address} from '../../Api/AdressApi/DHLAddressApi'
import { CommonModule, AsyncPipe } from '@angular/common';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap, of, filter, from, Observable, OperatorFunction } from 'rxjs';
import { Address } from '../../Api/DcoApi/Address';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap/typeahead';

@Component({
  imports: [
   Combobox,
    ComboboxInput,
    ComboboxPopupContainer,
    Listbox,
    Option,
    OverlayModule,
    FormsModule,
    AsyncPipe,
    CommonModule,
    NgbTypeahead
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'Address',
  templateUrl: './AddressEdit.html',
  standalone: true,
  styleUrl: './AddressEdit.css'
})
export class AddressEdit {

  Api: dhl_address_api;

  isEditable: boolean = false;

  toggleIsEdit() {
    this.isEditable = !this.isEditable;
  }


  Items: OperatorFunction<string, address[]> = (text$: Observable<string>) =>
    text$.pipe(
      //debounceTime(800),
      distinctUntilChanged(),
      switchMap(async (term) => {
        if (term?.length > 3 && term.trimStart().includes(" ")) {
          return await this.Api.search(term.trim().replace(" ", "+"));
        }
        // Falls Bedingung nicht erfüllt: Leeres Array zurückgeben
        return [];
      })
    );

  formatter: (obj: any) => string = obj => this.formatAddress(obj);


  formatAddress(address: any): string {
    if (!address) return '';
    // Achte auf Kleinschreibung, da Nominatim meist kleingeschriebene Keys liefert
    return `${address.street ?? ''} ${address.houseNumber ?? ''}, ${address.postalCode ?? ''} ${address.city ?? ''}`.trim();
  }
  constructor() {
    // Scrolls to the active item when the active option changes.
    // The slight delay here is to ensure animations are done before scrolling.

    this.Api = new dhl_address_api();


  }

  get AddressIntern(): Address {
    if (!this.address || this.address == null) {
      this.address = {};
      this.addressChange.emit(this.address);
    }


    return this.address;

  }


  onInputBlur(event: FocusEvent) {

  }


  @Input() address: Address | null = null;

  slection: any = null;

  // MUST be named exactly 'addressChange' for [(address)] to work
  @Output() addressChange = new EventEmitter<Address | null>();

  updateFormFields(selection: any) {
    if (this.address == null) {
      this.address = new Address();
    }

    if (selection != null) {
      this.address.hausnummer = selection?.houseNumber;
      this.address.ort = selection?.city;
      this.address.plz = selection?.postalCode;
      this.address.strasse = selection?.street;
      this.addressChange.emit(this.address);
    }
  }
}


* */
